import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { getTalentHistory } from '../api/talentsApi';

type UseAuditLogsResponse = {
  data: HistoryLogEntryResponse[],
  isLoading: boolean,
  isError: boolean,
  error: AxiosError | null,
  isFetching: boolean,
  refetch: () => void,
}

export const useHistoryLogsTalent = (
  talentId: string,
  onCallback: () => void,
):UseAuditLogsResponse => {
  const {
    data,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,
  } = useQuery<HistoryLogResponse, AxiosError>(
    ['talent-history', talentId],
    () => {
      return getTalentHistory(talentId);
    }, {
      onSuccess: () => {
        onCallback();
      },
      enabled: !!talentId,
      retry: false,
    });

  return {
    data: data?.logs || [],
    isLoading,
    isError,
    error,
    isFetching,
    refetch,
  };
};
